import React, { memo, useState, useEffect } from "react";
import { compose } from "redux";

import connectActions from "fantastic/lib/connectActions";
import connectProps from "fantastic/lib/connectProps";
import utils from "fantastic/lib/utils";
import sectionsOperations from "fantastic/lib/sections";
import actions from "fantastic/actions";

import setHovered from "../../actions/setHovered";
import setSelected from "../../actions/setSelected";
import getHovered from "fantastic/selectors/getHovered";
import droppable from "fantastic/components/hoc/droppable";
import ClickTools from "fantastic/components/hoc/draggable/ClickTools";

import Section from "./body/Section";

const Template = ({ sections, theme, setSelected, update, style }) => {
  const [clicked, setClicked] = useState(false);
  const [points, setPoints] = useState({ x: 0, y: 0 });

  const handleScroll = event => {
    const mouseY = event.clientY;

    if (mouseY < 100) {
      window.scrollBy(0, -10);
    }
  };

  useEffect(() => {
    window.addEventListener("dragover", handleScroll);
    return () => {
      window.removeEventListener("dragover", handleScroll);
    };
  },[]);

  const handleClick = event => {
    clicked && setClicked(false);

    const selectedNode = event.target.closest("[data-selectable-id]");
    if (selectedNode) {
      const nodeId = selectedNode.dataset.selectableId;
      setSelected(nodeId);
    }
  };

  const globaBackgroundStyles = {
    backgroundColor: theme.style_attributes["base-bg"],
    backgroundImage: utils.url(theme.style_attributes["base-bg-image"]),
    backgroundRepeat: theme.style_attributes["base-bg-repeat"],
    backgroundPosition: theme.style_attributes["base-bg-position"],
    // minHeight: "100vh"
  };

  const contextMenu = () => {
    clicked && setClicked(false)
    let presentMenu = true
    const selectedNode = event.target.closest("[data-selectable-id]");

    if (selectedNode) {
      const nodeId = selectedNode.dataset.selectableId;
      presentMenu = sectionsOperations.byId(nodeId, sections).kind != "block"
      setSelected(nodeId);
    }

    if (presentMenu) {
      setClicked(true);
      setPoints({ x: event.clientX, y: event.clientY });
    }

    presentMenu && event.preventDefault();
  };

  return (
    <div className="fantastic-body" onClick={handleClick} style={style} onContextMenu={contextMenu}>
      <div className="ink">
        <table className="mail" style={globaBackgroundStyles}>
          <tbody>
            <tr>
              <td className="center" align="center" valign="top">
                {sections.map(section => (
                  <Section key={section.id} {...section} checkContrast={(c) => c}/>
                ))}

                {clicked && <ClickTools top={points.y} left={points.x} />}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
};

const arePropsEqual = (prev, next) => {
  return JSON.stringify(prev) === JSON.stringify(next);
};

export default compose(
  connectProps("sections", "theme"),
  connectActions({ setSelected, update: actions.updateNode }),
  droppable("SECTION", true)
)(Template);
